import React from "react"
import { graphql } from "gatsby"

// HS Marketing Shared Components
import { DefaultPrefooter } from "@helpscout/hs-marketing-shared-components"

import useCommmonUrlsAndNumbers from "@hooks/useCommonUrlsAndNumbers"

import Content from "@components/Content/Content"
import SEO from "@components/SEO/SEO"

import IntegrationPageHero from "./components/IntegrationPageHero/IntegrationPageHero"
import IntegrationPageBreadcrumbSchema from "./components/IntegrationPageBreadcrumbSchema/IntegrationPageBreadcrumbSchema"
import ZapierZaps from "./components/ZapierZaps/ZapierZaps"

import {
  IntegrationPageContentDIV,
} from "./IntegrationPage.styles"

export const Head = ({
  data: {
    integration: {
      category,
      slug,
      subtitle,
      title,
    },
  },
}) => (
  <SEO
    category={category[0]}
    description={subtitle}
    image="/images/pages/help-desk-integration/integrations--meta.png"
    permalink={`/help-desk-integration/${slug}/`}
    title={`Integrate ${title} with Help Scout`}
    type="article"
  />
)

const IntegrationPage = ({
  data: {
    integration: {
      content,
      featuredLogo,
      isFeatured,
      logo,
      slug,
      subtitle,
      title,
    },
  },
}) => {
  const { demoUrl, signupPlusUrl } = useCommmonUrlsAndNumbers()
  return (
  <>
    <IntegrationPageBreadcrumbSchema
      permalink={`/help-desk-integration/${slug}`}
      title={`Integrate ${title} with Help Scout`}
    />
    <IntegrationPageHero
      image={featuredLogo || logo}
      isFeatured={isFeatured}
      permalink={`/help-desk-integration/${slug}`}
      slug={slug}
      subtitle={subtitle}
      title={title}
    />
    <div className="container">
      <section style={{ padding: "var(--spacing--L) 0" }}>
        <IntegrationPageContentDIV>
          <Content content={content} />
          {slug === "zapier" && (
            <ZapierZaps ids="2584,4179,4198,3847,8335,4199,4190,19580,26116,8315,4200,8975,18359,14970,4191,1076,12153,16068,13648,4180,15595,20592,7469,12246,13339,36562,32948" />
          )}
        </IntegrationPageContentDIV>
      </section>
    </div>
    <DefaultPrefooter {...{ demoUrl, signupPlusUrl }} />
  </>
)
}

export const pageQuery = graphql`
  query IntegrationPageQuery(
    $id: String!
  ) {
    integration: contentfulIntegration(id: { eq: $id }) {
      content {
        raw
        references {
          __typename
          ... on ContentfulContentBlockBlockquote {
            ...ContentBlockquoteFragment
          }
          ... on ContentfulContentBlockCallout {
            ...ContentCalloutFragment
          }
          ... on ContentfulContentBlockImages {
            ...ContentImagesFragment
          }
          ... on ContentfulContentBlockVideo {
            ...VideoFragment
          }
        }
      }
      category
      featuredLogo {
        imgixImage {
          url
          gatsbyImageData(width: 148)
        }
      }
      isFeatured
      logo {
        imgixImage {
          url
          gatsbyImageData(width: 130)
        }
      }
      slug
      subtitle
      title
    }
  }
`

export default IntegrationPage
